module.exports = __webpack_public_path__ + "static/media/4.804f8fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/九宫格选中态/4.png
// module id = 952
// module chunks = 0